
export const APP_URL = 'https://charge.mer.eco'
export const GMT_ID = 'GTM-KJWWHXX'

